import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StepperItem from './stepperItem';
import styles from './stepper.module.scss';

class Stepper extends Component {
    getStepperComponents = (stepperArray, currentPageId) => {
        return stepperArray.map((item, key) => {
            return (
                <StepperItem
                    {...item}
                    key={key}
                    isCurrentLink={currentPageId === item.id}
                />
            )
        })
    }

    render() {
        const { currentPageId, stepperArray } = this.props;
        return (
            <div className={styles['stepper-container']}>
                {this.getStepperComponents(stepperArray, currentPageId)}
            </div>
        )
    }
}

Stepper.defaultProps = {
    stepperArray: [
        {
            url: 'intro1',
            text: 'About Company',
            isLinkVisited: false,
            isConnectorNeeded: false
        },
        {
            url: 'intro2',
            text: 'About Character',
            isLinkVisited: false,
            isConnectorNeeded: false
        },
        {
            url: 'intro3',
            text: 'Objectives',
            isLinkVisited: false,
            isConnectorNeeded: false
        }
    ]
}

Stepper.propTypes = {

}

export default Stepper;


// WEBPACK FOOTER //
// /src/components/intro/pages/about/stepper/Stepper.js